<template>
  <div class="setup-container">
    <v-btn
      id="button-save-setup"
      v-if="showStickySaveButton"
      color="success"
      size="large"
      variant="elevated"
      @click="Update"
      :loading="dialog"
      :disabled="dialog"
      prepend-icon="mdi-content-save"
      class="save-action-button sticky-save-btn"
      rounded="lg"
    >
      <template v-slot:prepend>
        <v-icon size="20">mdi-content-save</v-icon>
      </template>
        {{ $t('save') }} Configuration
    </v-btn>
    <v-container fluid class="pa-6">
      <!-- Header Section -->
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("general_title")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
    
      <!-- Configuration Cards -->
      <div class="config-grid">
        <v-row justify="end" class="mt-4">
          <v-btn
              color="success"
              size="large"
              variant="elevated"
              @click="Update"
              :loading="dialog"
              :disabled="dialog"
              prepend-icon="mdi-content-save"
              class="save-action-button"
              rounded="lg"
              style="margin-right: 12px;"
            >
              <template v-slot:prepend>
                <v-icon size="20">mdi-content-save</v-icon>
              </template>
              {{ $t('save') }} Configuration
            </v-btn>
        </v-row>

      
        <!-- GPT Configuration Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-robot</v-icon>
            <span>GPT Configuration</span>
          </v-card-title>
          <v-card-text class="card-content">
            <!-- Azure OpenAI Endpoints -->
            <div class="section-title">Azure OpenAI Endpoints</div>

            <div
              v-for="(item, index) in setupListAzureOpenAIEndpoint"
              :key="item.id"
              class="endpoint-card"
            >
              <v-row no-gutters>
                <v-col cols="12" md="2">
                  <v-text-field
                    label="Priority"
                    v-model="item.priorityDisplay"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                    @keypress="isNumberpositive($event)"
                    class="priority-field"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey"
                        >mdi-sort-numeric-ascending</v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="px-2">
                  <v-text-field
                    label="Azure OpenAI URL"
                    v-model="item.azureOpenAIUrl"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey">mdi-link</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="px-2">
                  <v-text-field
                    label="API Key"
                    v-model="item.azureOpenAIAPIKey"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                    :type="item.showValue ? 'text' : 'password'"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey">mdi-key</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn
                        icon
                        size="small"
                        variant="text"
                        density="comfortable"
                        @click="item.showValue = !item.showValue"
                      >
                        <v-icon size="small">{{
                          item.showValue ? "mdi-eye" : "mdi-eye-off"
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="d-flex align-center justify-end">
                  <v-btn
                    v-if="index !== 0"
                    icon
                    color="error"
                    variant="text"
                    density="comfortable"
                    @click="Delete(index)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <v-btn
              outlined
              color="primary"
              @click="Add()"
              class="add-endpoint-btn"
              v-show="setupListAzureOpenAIEndpoint.length > 0"
            >
              <v-icon location="left">mdi-plus</v-icon>
              Add Endpoint
            </v-btn>

            <!-- Embedding Configuration -->
            <v-divider class="my-6"></v-divider>
            <div class="section-title">Embedding Configuration</div>

            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-switch
                  v-model="setup.EmbLoadBalanceMode"
                  inset
                  class="modern-switch"
                  color="blue"
                >
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text"
                        density="comfortable" class="mr-2">mdi-debug-step-over</v-icon>
                      <span>
                        {{
                          "Embedding Load Balance : " +
                          (setup.EmbLoadBalanceMode == "0" ? "OFF" : "ON")
                        }}
                      </span>
                      <label v-bind="attrs" v-on="on"></label>
                    </div>
                  </template>
                </v-switch>
              </v-col>
            </v-row>

            <v-row v-show="setupListAzureOpenAIEndpoint.length > 0 && setup.EmbLoadBalanceMode == '0'">
              <v-col cols="12" md="6">
                <v-text-field
                  label="Embedding URL"
                  v-model="setup.AzureOpenAIEmbeding_Url"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-vector-triangle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Embedding API Key"
                  v-model="setup.AzureOpenAIEmbeding_APIKey"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                  :type="setup.Show_AzureOpenAI_APIKey ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-key</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      density="comfortable"
                      @click="
                        setup.Show_AzureOpenAI_APIKey =
                          !setup.Show_AzureOpenAI_APIKey
                      "
                    >
                      <v-icon small>{{
                        setup.Show_AzureOpenAI_APIKey
                          ? "mdi-eye" : "mdi-eye-off"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Embedding API Version"
                  v-model="setup.AzureOpenAIEmbeding_APIVersion"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-version</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  id="embedingType-setup"
                  label="Embedding Type"
                  :items="azureOpenAI_EmbedingType_List"
                  item-title="text"
                  item-value="value"
                  v-model="setup.AzureOpenAI_EmbedingType"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-format-list-bulleted</v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <!-- GPT Mode Configuration -->
            <v-divider class="my-6"></v-divider>
            <div class="section-title">GPT Mode Configuration</div>

            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-switch
                  v-model="setup.GPTMode"
                  inset
                  :label="`GPT Mode : ${
                    setup.GPTMode == '0' ? 'Priority' : 'Fast'
                  }`"
                  small
                  color="primary"
                >
                  <template v-slot:label>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <label v-bind="attrs" v-on="on">{{
                          "GPT Mode : " +
                          (setup.GPTMode == "0" ? "Priority" : "Fast")
                        }}</label>
                      </template>
                      <span>GPT Mode</span>
                    </v-tooltip>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row v-show="setup.GPTMode == '1'">
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  label="Repeat Time (Minutes)*"
                  v-model="setup.GPTRepeatTime"
                  @keypress="isNumber($event)"
                  required
                  density="comfortable"
                  variant="outlined"
                  :rules="[rules.required]"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-clock</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  label="Model*"
                  :items="DDModelShow"
                  item-title="modelDisplay"
                  item-value="modelName"
                  density="comfortable"
                  variant="outlined"
                  clearable
                  v-model="setup.Model"
                  :rules="[rules.required]"
                  required
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-robot-happy</v-icon>
                  </template>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          text
                          size="small"
                          variant="text"
                          density="comfortable"
                          style="position: absolute; top: 0px; right: -6px"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-information-outline</v-icon
                        >
                      </template>
                      <span>{{ $t("_InfoModel") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-show="setup.GPTMode == '1'">
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  id="Questions"
                  label="Test of Questions*"
                  density="comfortable"
                  variant="outlined"
                  counter
                  auto-grow
                  rows="6"
                  v-model="setup.Questions"
                  :maxlength="1000"
                  :rules="[rules.required]"
                  required
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-comment-question</v-icon>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-data-table
              v-show="setup.GPTMode == '1'"
              :items="listAzureEndpointFastMode"
              :headers="headers"
              hide-default-footer
              :items-per-page="listAzureEndpointFastMode.length"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">{{ item.priority }}</td>
                  <td>{{ item.azureOpenAIUrl }}</td>
                  <td>{{ item.responseTime }}</td>
                  <td>{{ item.replytext }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <!-- OpenAI Configuration Card -->
        <!-- <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="green" class="mr-3">mdi-brain</v-icon>
            <span>OpenAI Configuration</span>
          </v-card-title>
          <v-card-text class="card-content">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="OpenAI URL"
                  v-model="setup.openAIUrl"
                  :rules="[rules.required]"
                  outlined
                  dense
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-link</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="API Key"
                  v-model="setup.openAIAPIKey"
                  :rules="[rules.required]"
                  outlined
                  dense
                  :type="setup.Show_OpenAI_APIKey ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-key</v-icon>
                  </template>
                  <template v-slot:append>
                    <v-btn
                      icon
                      small
                      @click="setup.Show_OpenAI_APIKey = !setup.Show_OpenAI_APIKey"
                    >
                      <v-icon small>{{ setup.Show_OpenAI_APIKey ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card> -->

        <!-- Storage Configuration Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-database</v-icon>
            <span>Storage Configuration</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="storage-section">
              <div class="section-subtitle">Azure Blob Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageConnection"
                    :rules="[rules.required]"
                    :type="
                      setup.Show_AzureStorageConnection ? 'text' : 'password'
                    "
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn
                        icon
                        size="small"
                        variant="text"
                        density="comfortable"
                        @click="
                          setup.Show_AzureStorageConnection =
                            !setup.Show_AzureStorageConnection
                        "
                      >
                        <v-icon size="small" variant="text"
                        density="comfortable">{{
                          setup.Show_AzureStorageConnection
                            ? "mdi-eye"
                            : "mdi-eye-off"
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Container Name"
                    v-model="setup.azureContainer"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">PDF Vector Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageConnectionPDFVector"
                    :rules="[rules.required]"
                    :type="
                      setup.Show_AzureStorageConnectionPDFVector
                        ? 'text'
                        : 'password'
                    "
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn
                        icon
                        size="small"
                        variant="text"
                        density="comfortable"
                        @click="
                          setup.Show_AzureStorageConnectionPDFVector =
                            !setup.Show_AzureStorageConnectionPDFVector
                        "
                      >
                        <v-icon size="small" variant="text"
                        density="comfortable">{{
                          setup.Show_AzureStorageConnectionPDFVector
                            ? "mdi-eye"
                            : "mdi-eye-off"
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Container Name"
                    v-model="setup.azureContainerPDFVector"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">Image Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageConnectionImage"
                    :rules="[rules.required]"
                    :type="
                      setup.Show_AzureStorageConnectionImage
                        ? 'text'
                        : 'password'
                    "
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn
                        icon
                        size="small"
                        variant="text"
                        density="comfortable"
                        @click="
                          setup.Show_AzureStorageConnectionImage =
                            !setup.Show_AzureStorageConnectionImage
                        "
                      >
                        <v-icon size="small" variant="text"
                        density="comfortable">{{
                          setup.Show_AzureStorageConnectionImage
                            ? "mdi-eye"
                            : "mdi-eye-off"
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Container Name"
                    v-model="setup.azureContainerImage"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">Speech Document Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageSpeech"
                    :rules="[rules.required]"
                    :type="setup.Show_AzureStorageSpeech ? 'text' : 'password'"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn
                        icon
                        size="small"
                        variant="text"
                        density="comfortable"
                        @click="
                          setup.Show_AzureStorageSpeech =
                            !setup.Show_AzureStorageSpeech
                        "
                      >
                        <v-icon size="small" variant="text"
                        density="comfortable">{{
                          setup.Show_AzureStorageSpeech
                            ? "mdi-eye"
                            : "mdi-eye-off"
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Container Name"
                    v-model="setup.azureContainerSpeech"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">Quick Reply Icon Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureQuickReplyIconStorage"
                    :rules="[rules.required]"
                    :type="
                      setup.Show_AzureQuickReplyIconStorage
                        ? 'text'
                        : 'password'
                    "
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn
                        icon
                        size="small"
                        variant="text"
                        density="comfortable"
                        @click="
                          setup.Show_AzureQuickReplyIconStorage =
                            !setup.Show_AzureQuickReplyIconStorage
                        "
                      >
                        <v-icon size="small" variant="text"
                        density="comfortable">{{
                          setup.Show_AzureQuickReplyIconStorage
                            ? "mdi-eye"
                            : "mdi-eye-off"
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Container Name"
                    v-model="setup.azureQuickReplyIconContainer"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>

        <!-- Language Services Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-translate</v-icon>
            <span>Language Services</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="service-tabs">
              <v-tabs
                v-model="activeLanguageTab"
                color="primary"
                slider-color="primary"
              >
                <v-tab>Translator</v-tab>
                <v-tab>Language Service</v-tab>
                <v-tab>Speech to Text</v-tab>
              </v-tabs>

              <!-- แก้ไขจาก v-tabs-items เป็น v-window -->
              <v-window v-model="activeLanguageTab">
                <v-window-item>
                  <v-row class="mt-4">
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Endpoint"
                        v-model="setup.languageTranslatorEndpoint"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-link</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="API Key"
                        v-model="setup.languageTranslatorKey"
                        :rules="[rules.required]"
                        :type="
                          setup.Show_LanguageTranslatorKey ? 'text' : 'password'
                        "
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-key</v-icon>
                        </template>
                        <template v-slot:append-inner>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            density="comfortable"
                            @click="
                              setup.Show_LanguageTranslatorKey =
                                !setup.Show_LanguageTranslatorKey
                            "
                          >
                            <v-icon size="small" variant="text"
                        density="comfortable">{{
                              setup.Show_LanguageTranslatorKey
                                ? "mdi-eye"
                                : "mdi-eye-off"
                            }}</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Location"
                        v-model="setup.languageTranslatorLocation"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-map-marker</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-window-item>
                <v-window-item>
                  <v-row class="mt-4">
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Language Endpoint"
                        v-model="setup.languageEndpoint"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-link</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Language Key"
                        v-model="setup.languageKey"
                        :rules="[rules.required]"
                        :type="setup.Show_LanguageKey ? 'text' : 'password'"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-key</v-icon>
                        </template>
                        <template v-slot:append-inner>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            density="comfortable"
                            @click="
                              setup.Show_LanguageKey = !setup.Show_LanguageKey
                            "
                          >
                            <v-icon size="small" variant="text"
                        density="comfortable">{{
                              setup.Show_LanguageKey ? "mdi-eye" : "mdi-eye-off"
                            }}</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-window-item>
                <v-window-item>
                  <v-row class="mt-4">
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Speech to Text Key"
                        v-model="setup.speechToTextKey"
                        :rules="[rules.required]"
                        :type="setup.Show_SpeechToTextKey ? 'text' : 'password'"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-key</v-icon>
                        </template>
                        <template v-slot:append-inner>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                        density="comfortable"
                            @click="
                              setup.Show_SpeechToTextKey =
                                !setup.Show_SpeechToTextKey
                            "
                          >
                            <v-icon size="small" variant="text"
                        density="comfortable">{{
                              setup.Show_SpeechToTextKey
                                ? "mdi-eye"
                                : "mdi-eye-off"
                            }}</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Speech to Text Region"
                        v-model="setup.speechToTextRegion"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable"
                            >mdi-map-marker-outline</v-icon
                          >
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Speech to Text Language"
                        v-model="setup.speechToTextLanguage"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-translate</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <!-- add field Path FFmpeg -->
                      <v-text-field
                        label="FFmpeg Path"
                        v-model="setup.pathFFMpeg"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-folder</v-icon>
                        </template>
                      </v-text-field>

                    </v-col>
                    <v-col cols="12" md="6">
                      <!-- add field Path FFmpeg local -->
                      <v-text-field
                        label="FFmpeg Local Path"
                        v-model="setup.pathFFMpegLocal"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-folder</v-icon>
                        </template>
                      </v-text-field>

                    </v-col>
                  </v-row>
                </v-window-item>
              </v-window>
            </div>
          </v-card-text>
        </v-card>
        <!-- Mail Config -->
         <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-mail</v-icon>
            <span>Mail Config</span>
          </v-card-title>
          <v-card-text class="card-content">
            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <v-text-field
                  label="Email Host"
                  v-model="setup.emailHost"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-email</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <!-- add field Host name -->
                <v-text-field
                  label="Host Name"
                  v-model="setup.hostName"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-domain</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <!-- add field Password -->
                <v-text-field
                  label="Password"
                  v-model="setup.password"
                  :rules="[rules.required]"
                  :type="setup.Show_Password ? 'text' : 'password'"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-lock</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      density="comfortable"
                      @click="
                        setup.Show_Password = !setup.Show_Password
                      "
                    >
                      <v-icon size="small" variant="text"
                        density="comfortable">{{
                        setup.Show_Password ? "mdi-eye" : "mdi-eye-off"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
         </v-card>
        <!-- System Settings Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-cog</v-icon>
            <span>System Settings</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="settings-grid">
              <div class="setting-item">
                <v-switch
                  v-model="setup.autoStream"
                  color="blue"
                  class="modern-switch"
                  inset
                >
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text"
                        density="comfortable" class="mr-2">mdi-lightning-bolt</v-icon>
                      <span
                        >Auto Stream:
                        {{ setup.autoStream ? "Enabled" : "Disabled" }}</span
                      >
                    </div>
                  </template>
                </v-switch>
              </div>

              <div class="setting-item">
                <v-switch
                  v-model="setup.anonymous"
                  color="blue"
                  class="modern-switch"
                  inset
                >
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text"
                        density="comfortable" class="mr-2">mdi-incognito</v-icon>
                      <span
                        >Anonymous Mode:
                        {{ setup.anonymous ? "On" : "Off" }}</span
                      >
                    </div>
                  </template>
                </v-switch>
              </div>
            </div>

            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <v-text-field
                  label="Time Delay (ms)"
                  v-model="setup.TimeDelayCharacter"
                  @keypress="isNumber($event)"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-timer</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Character Limit"
                  v-model="setup.LimitedCharacter"
                  @keypress="isNumber($event)"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-format-letter-case</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <div class="settings-grid">
              <div class="setting-item">
                <v-switch
                  v-model="setup.FlagDisableGPT"
                  color="blue"
                  class="modern-switch"
                  inset
                >
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text"
                        density="comfortable" class="mr-2">mdi-gift</v-icon>
                      <span
                        >Force Disable GPT</span
                      >
                    </div>
                  </template>
                </v-switch>
              </div>
              <div cols="12" md="6" class="setting-item">                
                <v-switch
                  v-model="setup.FlagAutoDisableGPT"
                  color="blue"
                  class="modern-switch"
                  inset
                >
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text"
                        density="comfortable" class="mr-2">mdi-repeat</v-icon>
                      <span
                        >Auto Disable GPT:
                        {{ setup.FlagAutoDisableGPT ? "on" : "off" }}</span
                      >
                    </div>
                  </template>
                </v-switch>
              </div>
            </div>

            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <!-- add field GPT Auto-Disable Period -->
                <v-text-field
                  label="GPT Auto-Disable Date Period"
                  v-model="setup.AutoDisableGPTPeriodDate"
                  @keypress="isNumber($event)"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-timer-sand</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <!-- add field GPT Auto-Disable Message -->
                <v-text-field
                  label="GPT Auto-Disable Message"
                  v-model="setup.AutoDisableGPTMessage"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-comment-question</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="GPT Auto-Disable Pricing (USD)"
                  v-model="setup.AutoDisableGPTPricing"
                  @keypress="isNumber($event)"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-currency-usd</v-icon>
                  </template>
                </v-text-field>
                
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- other config -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-cog</v-icon>
            <span>Other Config</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="service-tabs">
              <v-tabs
                v-model="otherTab"
                color="primary"
                slider-color="primary"
              >
                <v-tab>Google Config</v-tab>
                <v-tab>ANTHROPIC CONFIG</v-tab>
              </v-tabs>
            </div>

            <v-window v-model="otherTab">
                <v-window-item>
                  <v-row class="mt-4">
                    <v-col cols="12" md="6">
                      <!-- add field ProjectID -->
                      <v-text-field
                        label="Project ID"
                        v-model="setup.projectID"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-projector</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <!-- add field LocationID -->
                      <v-text-field
                        label="Location ID"
                        v-model="setup.locationID"
                        :rules="[rules.required]"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-map-marker</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" style="display: flex; justify-content: end; gap: 4px;" class="d-flex justify-between align-center mb-3 mr-3">
                       <span class="mt-3">JSON Credential</span>
                      <!--<v-icon :disabled="!isUploadFileJSON" color="green" large> mdi-check-circle </v-icon>
                      <span>{{ tempFileJSON != null && tempFileJSON != '' && tempFileJSON != undefined ? tempFileJSON.name : '' }}</span> -->
                      <DragDropFile :dialog="true" :DragDrop="false" :ShowListFile="false" :allowType="['application/json']" :accept="'application/json'" @filesUploaded="uploadFile($event)" />
                      <v-icon class="mt-3" :disabled="!isUploadFileJSON" color="green" large style="padding-top: 10px"> mdi-check-circle </v-icon>
                      <span>{{ tempFileJSON != null && tempFileJSON != '' && tempFileJSON != undefined ? tempFileJSON.name : '' }}</span>
                    </v-col>
                  </v-row>
                </v-window-item>

                <v-window-item>
                  <v-row class="mt-4">
                    <v-col cols="12" md="12">
                      <v-text-field
                        label="Anthropic APIKey"
                        v-model="setup.amazonClaude_APIKey"
                        :rules="[rules.required]"
                        :type="setup.Show_AmazonClaude_APIKey ? 'text' : 'password'"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-key</v-icon>
                        </template>
                        <template v-slot:append-inner>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            density="comfortable"
                            @click="
                              setup.Show_AmazonClaude_APIKey =
                                !setup.Show_AmazonClaude_APIKey
                            "
                          >
                            <v-icon size="small" variant="text"
                        density="comfortable">{{
                              setup.Show_AmazonClaude_APIKey
                                ? "mdi-eye"
                                : "mdi-eye-off"
                            }}</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>

        <!-- single sign on -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-cog</v-icon>
            <span>Single Sing-On</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="service-tabs">
              <v-tabs
                v-model="signOnTab"
                color="primary"
                slider-color="primary"
              >
                <v-tab v-for="(item, index) in setupOpenIDConnectList" :key="index">{{ item.provider }}</v-tab>
              </v-tabs>
            </div>

            <v-window v-model="signOnTab" class="mt-4">
                <v-window-item v-for="(item, index) in setupOpenIDConnectList" :key="index">
                      <div class="settings-grid">
                        <div class="setting-item" >
                          <v-switch
                            v-model="item.sso"
                            color="blue"
                            class="modern-switch"
                            inset
                          >
                            <template v-slot:label>
                              <div class="switch-label">
                                <v-icon size="small" variant="text"
                                  density="comfortable" class="mr-2">mdi-account-switch</v-icon>
                                <span
                                  >{{ 'Single Sign-On ' + item.provider + ': ' + (item.sso ? 'Open' : 'Close') }}</span
                                >
                              </div>
                            </template>
                          </v-switch>
                        </div>
                        <div class="setting-item">
                          <v-switch
                            v-model="item.ssoChat"
                            color="blue"
                            class="modern-switch"
                            inset
                          >
                            <template v-slot:label>
                              <div class="switch-label">
                                <span
                                  >{{ 'Single Sign-On ' + item.provider + ' in Chat: ' + (item.ssoChat ? 'Open' : 'Close') }}</span
                                >
                              </div>
                            </template>
                          </v-switch>
                        </div>
                      </div>
                      <v-row>
                        <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Line'">
                          <v-text-field
                            label="Instance"
                            v-model="item.instance"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                            :disabled="item.provider == 'Microsoft'"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                            </template>
                        
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Authentik' && item.provider != 'Line'">
                          <v-text-field
                            label="Domain"
                            v-model="item.domain"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-domain</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Authentik' && item.provider != 'Line'">
                          <v-text-field
                            label="Tenant ID"
                            v-model="item.tenantId"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                            :type="item.Show_TenantId ? 'text' : 'password'"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-domain</v-icon>
                            </template>
                            <template v-slot:append-inner>
                              <v-btn
                                icon
                                size="small"
                                variant="text"
                                density="comfortable"
                                @click="item.Show_TenantId = !item.Show_TenantId"
                              >
                                <v-icon size="small" variant="text" density="comfortable">{{
                                  item.Show_TenantId ? "mdi-eye" : "mdi-eye-off"
                                }}</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            label="Client ID"
                            v-model="item.clientId"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                            :type="item.Show_ClientId ? 'text' : 'password'"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                            </template>
                            <template v-slot:append-inner>
                              <v-btn
                                icon
                                size="small"
                                variant="text"
                                density="comfortable"
                                @click="item.Show_ClientId = !item.Show_ClientId"
                              >
                                <v-icon size="small" variant="text" density="comfortable">{{
                                  item.Show_ClientId ? "mdi-eye" : "mdi-eye-off"
                                }}</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Authentik'">
                          <v-text-field
                            label="Callback Path"
                            v-model="item.callbackPath"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-link</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            label="Client Secret"
                            v-model="item.clientSecret"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                            :type="item.Show_ClientSecret ? 'text' : 'password'"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-lock</v-icon>
                            </template>
                            <template v-slot:append-inner>
                              <v-btn
                                icon
                                size="small"
                                variant="text"
                                density="comfortable"
                                @click="item.Show_ClientSecret = !item.Show_ClientSecret"
                              >
                                <v-icon size="small" variant="text" density="comfortable">{{
                                  item.Show_ClientSecret ? "mdi-eye" : "mdi-eye-off"
                                }}</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Authentik' && item.provider != 'Line'">
                          <v-text-field
                            label="API Scope"
                            v-model="item.apiScope"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                            :type="item.Show_APIScope ? 'text' : 'password'"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-scope</v-icon>
                            </template>
                            <template v-slot:append-inner>
                              <v-btn
                                icon
                                size="small"
                                variant="text"
                                density="comfortable"
                                @click="item.Show_APIScope = !item.Show_APIScope"
                              >
                                <v-icon size="small" variant="text" density="comfortable">{{
                                  item.Show_APIScope ? "mdi-eye" : "mdi-eye-off"
                                }}</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <!-- add field URLConfig -->
                          <v-text-field
                            label="URL Config"
                            v-model="item.urlConfig"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-web</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                </v-window-item>
            </v-window>

            
          </v-card-text>
        </v-card>

        <!-- Microsoft Entra ID Group Configuration Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-account-group</v-icon>
            <span>Microsoft Entra ID Group Configuration</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="settings-grid">
              <div class="setting-item">
                <v-switch
                  v-model="syncSSO"
                  color="blue"
                  class="modern-switch"
                  inset
                >
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text"
                        density="comfortable" class="mr-2">mdi-sync</v-icon>
                      <span>Sync SSO Groups</span>
                    </div>
                  </template>
                </v-switch>
              </div>
            </div>

            <v-row class="mt-4">
              <v-col cols="12" md="12">
                <v-text-field
                  label="Tenant ID"
                  v-model="setup.SecurityGroupTenantID"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                  :type="setup.Show_SecurityGroupTenantID ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-domain</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      density="comfortable"
                      @click="
                        setup.Show_SecurityGroupTenantID =
                          !setup.Show_SecurityGroupTenantID
                      "
                    >
                      <v-icon size="small" variant="text"
                        density="comfortable">{{
                        setup.Show_SecurityGroupTenantID
                          ? "mdi-eye"
                          : "mdi-eye-off"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-text-field
                  label="Client ID"
                  v-model="setup.SecurityGroupClientID"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                  :type="setup.Show_SecurityGroupClientID ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-key</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      density="comfortable"
                      @click="
                        setup.Show_SecurityGroupClientID =
                          !setup.Show_SecurityGroupClientID
                      "
                    >
                      <v-icon size="small" variant="text"
                        density="comfortable">{{
                        setup.Show_SecurityGroupClientID
                          ? "mdi-eye"
                          : "mdi-eye-off"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-text-field
                  label="ClientSecret"
                  v-model="setup.SecurityGroupClientSecrete"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                  :type="setup.Show_SecurityGroupClientSecrete ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text"
                        density="comfortable">mdi-lock</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      density="comfortable"
                      @click="
                        setup.Show_SecurityGroupClientSecrete =
                          !setup.Show_SecurityGroupClientSecrete
                      "
                    >
                      <v-icon size="small" variant="text"
                        density="comfortable">{{
                        setup.Show_SecurityGroupClientSecrete
                          ? "mdi-eye"
                          : "mdi-eye-off"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- ...existing other configuration cards with similar modern styling... -->
      </div>
    </v-container>

    <!-- Loading Dialog -->
    <v-dialog v-model="dialog" persistent width="320">
      <v-card class="loading-card">
        <v-card-text class="text-center py-6">
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
            class="mb-4"
          ></v-progress-circular>
          <div class="loading-text">Saving configuration...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import checkPermissionFour from "@/api/function.js";
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import DragDropFile from "@/components/DragDropFile.vue";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "Setup",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: { DragDropFile },
  mixins: [LogTrace],
  directives: {
    mask,
  },
  data: () => ({
    mask: "##########",
    showStickySaveButton: false,
    scrollThreshold: 145,
    items: [],
    panel: [0],
    activeLanguageTab: 0,
    otherTab: 0,
    signOnTab: 0,

    show1: false,
    formHasErrors: false,
    permission: {
      add: true,
      edit: true,
      delete: true,
    },
    mailcheck: false,
    phonecheck: false,
    filters: {
      username: [],
      email: [],
      employeeName: [],
      userType: [],
    },
    DDRole: [
      {
        name: "Admin",
        value: 1,
      },
      {
        name: "ผู้ใช้งานทั่วไป",
        value: 2,
      },
    ],
    numberRules: [(v) => !!v || "Input is required!"],
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 10 || "Min 10 numbers",
    },
    Email: null,
    gg: null,
    UserType: null,
    dialog: false,
    edit: {
      id: null,
      key: null,
      value: null,
    },
    user: {
      id: null,
      key: null,
      value: null,
    },

    Editdialog: false,
    Adddialog: false,
    isSearch: false,
    searchname: "",
    email: "",
    totalTable: 0,
    itemsPerPage: 10,
    searchTotalTable: 0,
    options: {},
    today: null,
    setupList: [],
    setupListAzureOpenAIEndpoint: [],
    DDModelShow: [],
    listAzureEndpointFastMode: [],
    setupOpenIDConnectList: [],
    setup: {
      azureOpenAI_URL: null,
      azureOpenAI_APIKey: null,
      azureStorageConnection: null,
      Show_AzureStorageConnection: false,
      azureContainer: null,
      azureStorageConnectionPDFVector: null,
      Show_AzureStorageConnectionPDFVector: false,
      azureContainerPDFVector: null,
      azureStorageConnectionImage: null,
      Show_AzureStorageConnectionImage: false,
      azureContainerImage: null,
      azureStorageSpeech: null,
      Show_AzureStorageSpeech: false,
      azureContainerSpeech: null,
      azureQuickReplyIconStorage: null,
      Show_AzureQuickReplyIconStorage: false,
      azureQuickReplyIconContainer: null,
      languageTranslatorKey: null,
      Show_LanguageTranslatorKey: false,
      languageTranslatorEndpoint: null,
      languageTranslatorLocation: null,
      languageKey: null,
      Show_LanguageKey: false,
      languageEndpoint: null,
      channelSecretInternal: null,
      channelTokenInternal: null,
      emailHost: null,
      hostName: null,
      password: null,
      Show_Password: false,
      openAIAPIKey: null,
      Show_OpenAI_APIKey: false,
      openAIUrl: null,
      speechToTextKey: null,
      Show_SpeechToTextKey: false,
      speechToTextRegion: null,
      speechToTextLanguage: null,
      pathFFMpeg: null,
      pathFFMpegLocal: null,
      autoStream: null,
      anonymous: null,
      TimeDelayCharacter: null,
      LimitedCharacter: null,
      AzureOpenAIEmbeding_Url: null,
      AzureOpenAIEmbeding_APIKey: null,
      Show_AzureOpenAI_APIKey: false,
      azureOpenAIEmbeding_APIVersion: null,
      AzureOpenAI_EmbedingType: null,
      projectID: null,
      locationID: null,
      fileJSON: null,
      amazonClaude_APIKey: null,
      Show_AmazonClaude_APIKey: false,
      GPTMode: "0",
      GPTRepeatTime: null,
      Model: null,
      Questions: null,
      SSO: null,
      SSOChat: null,
      instance: null,
      domain: null,
      tenantId: null,
      clientId: null,
      callbackPath: null,
      clientSecret: null,
      APIScope: null,
      URLConfig: null,
      SecurityGroupTenantID: null,
      Show_SecurityGroupTenantID: false,
      SecurityGroupClientID: null,
      Show_SecurityGroupClientID: false,
      SecurityGroupClientSecrete: null,
      Show_SecurityGroupClientSecrete: false,
      FlagAutoDisableGPT: null,
      FlagDisableGPT: null,
      AutoDisableGPTPeriodDate: null,
      AutoDisableGPTMessage: null,
      AutoDisableGPTPricing: null,
      EmbLoadBalanceMode: "0",
    },
    secretKey: "01234567890123456789012345678901",
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    azureOpenAI_EmbedingType_List: [
      { text: "text-embedding-3-large", value: "text-embedding-3-large" },
      { text: "text-embedding-3-small", value: "text-embedding-3-small" },
      { text: "text-embedding-ada-002", value: "text-embedding-ada-002" },
    ],
    myClipboard: "",
    myClipboardFullSteam: "",
    urlApi: import.meta.env.VITE_APP_API,
    tempFileJSON: null,
    isUploadFileJSON: false,
    syncSSO: false,
    oldsetup:{
      SecurityGroupTenantID: null,
      SecurityGroupClientID: null,
      SecurityGroupClientSecrete: null,
    },
  }),
  watch: {
    syncSSO: {
      handler(val) {
        let self = this;
        if (val) {
          // let ConfigData = self.setupOpenIDConnectList.find(
          //   (item) => item.provider == "Microsoft"
          // );
          self.setup.SecurityGroupTenantID = self.oldsetup.SecurityGroupTenantID;
          self.setup.SecurityGroupClientID = self.oldsetup.SecurityGroupClientID;
          self.setup.SecurityGroupClientSecrete = self.oldsetup.SecurityGroupClientSecrete;
        }
      },
      deep: true,
      immediate: true,
    },
    // setupOpenIDConnectList: {
    //   handler(val) {
    //     let self = this;
    //     const newItem = val.find((item) => item.provider === "Microsoft");
    //     if (self.syncSSO == true) {
    //       self.setup.SecurityGroupTenantID = newItem.tenantId;
    //       self.setup.SecurityGroupClientID = newItem.clientId;
    //       self.setup.SecurityGroupClientSecrete = newItem.clientSecret;
    //     }
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.GetDate();
    this.Get();
    this.GetDDLModelDataAzureProvider();
    this.myClipboard =
      `<script src="${this.urlApi}Snippet/ChatFrameworkSnippet.js"><` +
      "/script>";
    this.myClipboardFullSteam =
      `<script src="${this.urlApi}Snippet/ChatFrameworkSnippetFull.js"><` +
      "/script>";
    const scroller = document.querySelector('.v-main__scroller') || window;
    scroller.addEventListener('scroll', this.handleScroll, true);
    this._scrollContainer = scroller;
  },
  unmounted () {
    // ลบ listener ออกจาก container ที่แท้จริง
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener('scroll', this.handleScroll, true);
    }
  },

  computed: {
    form() {
      return {
        id: this.user.id,
        key: this.user.key,
        value: this.user.value,
      };
    },
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          value: "priority",
          sortable: false,
        },
        {
          title: "AzureOpenAIUrl",
          value: "azureOpenAIUrl",
          align: "left",
          sortable: true,
        },
        {
          title: "ResponseTime (Milliseconds)",
          value: "responseTime",
          align: "left",
          sortable: true,
        },
        { title: "Answers", value: "replytext", align: "left", sortable: true },
      ];
    },
  },

  methods: {
    handleScroll(event) {
       const { scrollTop } = event.target;
       const target = event.target;
        if (target.closest('.v-navigation-drawer') || 
            target.closest('.v-app-bar') || 
            target.closest('.v-toolbar')) {
          return;
        }
       if(scrollTop >= this.scrollThreshold) 
       {
         this.showStickySaveButton = true;
       } 
       else 
       {
         this.showStickySaveButton = false;
       }
   },
    Apply() {
      try {
        let self = this;
        self.dialog = true;
        self.$call.GetSetupApply(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              // self.Get();
              alert("Apply change");
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) {
        this.LogTrace(error, "Apply");
      }
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    setListAzureEndpointFastMode(data) {
      let self = this;
      let newList = data.sort((a, b) => a.priority - b.priority);
      let checkfastmode = data.filter((item) => item.responseTime !== null);
      if (checkfastmode.length == newList.length) {
        self.listAzureEndpointFastMode = newList.map((item) => {
          return {
            priority: item.priority,
            azureOpenAIUrl: item.azureOpenAIUrl,
            responseTime: item.responseTime == 0 ? "-" : item.responseTime,
            replytext: item.replytext,
          };
        });
      } else {
        self.listAzureEndpointFastMode = [];
      }
    },
    setListOpenIDConnect(data) {
      let self = this;
      self.setupOpenIDConnectList = data.map((item) => {
        return {
          provider: item.provider,
          sso: item.sso,
          ssoChat: item.ssoChat,
          instance: item.instance,
          domain: item.domain,
          tenantId: item.tenantId,
          Show_TenantId: false,
          clientId: item.clientId,
          Show_ClientId: false,
          callbackPath: item.callbackPath,
          clientSecret: item.clientSecret,
          Show_ClientSecret: false,
          apiScope: item.apiScope,
          Show_APIScope: false,
          urlConfig: item.urlConfig,
        };
      });
    },
    Get() {
      try {
        let self = this;
        self.$call.GetSetupOverviewGeneral(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.setupList = dataResponse.data.listDbsettings;
              if (dataResponse.data.listAzureOpenAIEndpoint.length == 0) {
                self.listAzureEndpointFastMode = [];
                self.Add();
              } else {
                self.setupListAzureOpenAIEndpoint =
                  dataResponse.data.listAzureOpenAIEndpoint.map((item) => ({
                    ...item,
                    showValue: false, // เพิ่ม key ใหม่ "showValue"
                  }));
                // self.setupListAzureOpenAIEndpoint = dataResponse.data.listAzureOpenAIEndpoint;
                self.setListAzureEndpointFastMode(
                  dataResponse.data.listAzureOpenAIEndpoint
                );
              }

              if (dataResponse.data.listOpenIDConnect.length == 0) {
                self.AddOpenIDConnect("Microsoft");
                self.AddOpenIDConnect("Authentik");
                self.AddOpenIDConnect("Line");
              } else {
                self.setListOpenIDConnect(dataResponse.data.listOpenIDConnect);

                if (
                  self.setupOpenIDConnectList.filter(
                    (item) => item.provider == "Microsoft"
                  ).length == 0
                ) {
                  self.AddOpenIDConnect("Microsoft");
                } else if (
                  self.setupOpenIDConnectList.filter(
                    (item) => item.provider == "Authentik"
                  ).length == 0
                ) {
                  self.AddOpenIDConnect("Authentik");
                } else if (
                  self.setupOpenIDConnectList.filter(
                    (item) => item.provider == "Line"
                  ).length == 0
                ) {
                  self.AddOpenIDConnect("Line");
                }
              }

              self.MapSetupList(self.setupList, false);
            }
            self.dialog = false;
            self.isSearch = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    MapSetupList(source, mapForSave) {
      let self = this;
      source.forEach((element) => {
        switch (element.key) {
          case "AzureContainer":
            element.value = mapForSave
              ? self.setup.azureContainer
              : element.value;
            self.setup.azureContainer = element.value;
            break;
          case "AzureContainerPDFVector":
            element.value = mapForSave
              ? self.setup.azureContainerPDFVector
              : element.value;
            self.setup.azureContainerPDFVector = element.value;
            break;
          case "AzureContainerImage":
            element.value = mapForSave
              ? self.setup.azureContainerImage
              : element.value;
            self.setup.azureContainerImage = element.value;
            break;
          case "AzureOpenAI_APIKey":
            element.value = mapForSave
              ? self.setup.azureOpenAI_APIKey
              : element.value;
            self.setup.azureOpenAI_APIKey = element.value;
            break;
          case "AzureOpenAI_Url":
            element.value = mapForSave
              ? self.setup.azureOpenAI_URL
              : element.value;
            self.setup.azureOpenAI_URL = element.value;
            break;
          case "AzureOpenAIEmbeding_APIKey":
            element.value = mapForSave
              ? self.setup.AzureOpenAIEmbeding_APIKey
              : element.value;
            self.setup.AzureOpenAIEmbeding_APIKey = element.value;
            break;
          case "AzureOpenAIEmbeding_Url":
            element.value = mapForSave
              ? self.setup.AzureOpenAIEmbeding_Url
              : element.value;
            self.setup.AzureOpenAIEmbeding_Url = element.value;
            break;
          case "AzureOpenAIEmbeding_APIVersion":
            element.value = mapForSave
              ? self.setup.AzureOpenAIEmbeding_APIVersion
              : element.value;
            self.setup.AzureOpenAIEmbeding_APIVersion = element.value;
            break;
          case "AzureOpenAI_EmbedingType":
            element.value = mapForSave
              ? self.setup.AzureOpenAI_EmbedingType
              : element.value;
            self.setup.AzureOpenAI_EmbedingType = element.value;
            break;
          case "AzureStorageConnection":
            element.value = mapForSave
              ? self.setup.azureStorageConnection
              : element.value;
            self.setup.azureStorageConnection = element.value;
            break;
          case "AzureStorageConnectionPDFVector":
            element.value = mapForSave
              ? self.setup.azureStorageConnectionPDFVector
              : element.value;
            self.setup.azureStorageConnectionPDFVector = element.value;
            break;
          case "AzureStorageConnectionImage":
            element.value = mapForSave
              ? self.setup.azureStorageConnectionImage
              : element.value;
            self.setup.azureStorageConnectionImage = element.value;
            break;
          case "AzureStorageSpeech":
            element.value = mapForSave
              ? self.setup.azureStorageSpeech
              : element.value;
            self.setup.azureStorageSpeech = element.value;
            break;
          case "AzureContainerSpeech":
            element.value = mapForSave
              ? self.setup.azureContainerSpeech
              : element.value;
            self.setup.azureContainerSpeech = element.value;
            break;
          case "AzureQuickReplyIconStorage":
            element.value = mapForSave
              ? self.setup.azureQuickReplyIconStorage
              : element.value;
            self.setup.azureQuickReplyIconStorage = element.value;
            break;
          case "AzureQuickReplyIconContainer":
            element.value = mapForSave
              ? self.setup.azureQuickReplyIconContainer
              : element.value;
            self.setup.azureQuickReplyIconContainer = element.value;
            break;
          // case "ChannelSecret_Internal":
          //   element.value = mapForSave
          //     ? self.setup.channelSecretInternal
          //     : element.value;
          //   self.setup.channelSecretInternal = element.value;
          //   break;
          // case "ChannelToken_Internal":
          //   element.value = mapForSave
          //     ? self.setup.channelTokenInternal
          //     : element.value;
          //   self.setup.channelTokenInternal = element.value;
          //   break;
          case "EmailHost":
            element.value = mapForSave ? self.setup.emailHost : element.value;
            self.setup.emailHost = element.value;
            break;
          case "HostName":
            element.value = mapForSave ? self.setup.hostName : element.value;
            self.setup.hostName = element.value;
            break;
          case "LanguageEndpoint":
            element.value = mapForSave
              ? self.setup.languageEndpoint
              : element.value;
            self.setup.languageEndpoint = element.value;
            break;
          case "LanguageKey":
            element.value = mapForSave ? self.setup.languageKey : element.value;
            self.setup.languageKey = element.value;
            break;
          case "LanguageTranslatorEndpoint":
            element.value = mapForSave
              ? self.setup.languageTranslatorEndpoint
              : element.value;
            self.setup.languageTranslatorEndpoint = element.value;
            break;
          case "LanguageTranslatorKey":
            element.value = mapForSave
              ? self.setup.languageTranslatorKey
              : element.value;
            self.setup.languageTranslatorKey = element.value;
            break;
          case "LanguageTranslatorLocation":
            element.value = mapForSave
              ? self.setup.languageTranslatorLocation
              : element.value;
            self.setup.languageTranslatorLocation = element.value;
            break;
          case "Password":
            element.value = mapForSave ? self.setup.password : element.value;
            self.setup.password = element.value;
            break;
          case "OpenAI_Url":
            element.value = mapForSave ? self.setup.openAIUrl : element.value;
            self.setup.openAIUrl = element.value;
            break;
          case "OpenAI_APIKey":
            element.value = mapForSave
              ? self.setup.openAIAPIKey
              : element.value;
            self.setup.openAIAPIKey = element.value;
            break;
          case "SpeechToTextKey":
            element.value = mapForSave
              ? self.setup.speechToTextKey
              : element.value;
            self.setup.speechToTextKey = element.value;
            break;
          case "SpeechToTextRegion":
            element.value = mapForSave
              ? self.setup.speechToTextRegion
              : element.value;
            self.setup.speechToTextRegion = element.value;
            break;
          case "SpeechToTextLanguage":
            element.value = mapForSave
              ? self.setup.speechToTextLanguage
              : element.value;
            self.setup.speechToTextLanguage = element.value;
            break;
          case "PathFFMpeg":
            element.value = mapForSave ? self.setup.pathFFMpeg : element.value;
            self.setup.pathFFMpeg = element.value;
            break;
          case "PathFFMpegLocal":
            element.value = mapForSave
              ? self.setup.pathFFMpegLocal
              : element.value;
            self.setup.pathFFMpegLocal = element.value;
            break;
          case "AutoStream":
            element.value = mapForSave
              ? self.setup.autoStream
                ? "1"
                : "0"
              : element.value == "1";
            self.setup.autoStream = element.value;
            break;
          case "Anonymous":
            element.value = mapForSave
              ? self.setup.anonymous
                ? "1"
                : "0"
              : element.value == "1";
            self.setup.anonymous = element.value;
            break;
          case "TimeDelayCharacter":
            element.value = mapForSave
              ? self.setup.TimeDelayCharacter
              : element.value;
            self.setup.TimeDelayCharacter = element.value;
            break;
          case "LimitedCharacter":
            element.value = mapForSave
              ? self.setup.LimitedCharacter || "5000"
              : element.value;
            self.setup.LimitedCharacter = element.value;
            break;
          case "FlagAutoDisableGPT":
            element.value = mapForSave
              ? self.setup.FlagAutoDisableGPT
                ? "1"
                : "0"
              : element.value == "1";
            self.setup.FlagAutoDisableGPT = element.value;
            break;
          case "FlagDisableGPT":
            element.value = mapForSave
              ? self.setup.FlagDisableGPT
                ? "1"
                : "0"
              : element.value == "1";
            self.setup.FlagDisableGPT = element.value;
            break;
          case "AutoDisableGPTPeriodDate":
            element.value = mapForSave
              ? self.setup.AutoDisableGPTPeriodDate
              : element.value;
            self.setup.AutoDisableGPTPeriodDate = element.value;
            break;
          case "AutoDisableGPTMessage":
            element.value = mapForSave
              ? self.setup.AutoDisableGPTMessage
              : element.value;
            self.setup.AutoDisableGPTMessage = element.value;
            break;
          case "AutoDisableGPTPricing":
            element.value = mapForSave
              ? self.setup.AutoDisableGPTPricing
              : element.value;
            self.setup.AutoDisableGPTPricing = element.value;
            break;
          case "ProjectID":
            element.value = mapForSave ? self.setup.projectID : element.value;
            self.setup.projectID = element.value;
            break;
          case "LocationID":
            element.value = mapForSave ? self.setup.locationID : element.value;
            self.setup.locationID = element.value;
            break;
          case "FileJSON":
            element.value = mapForSave ? self.setup.fileJSON : element.value;
            self.setup.fileJSON = element.value;
            if (
              self.setup.fileJSON != null &&
              self.setup.fileJSON != "" &&
              self.setup.fileJSON != undefined
            ) {
              self.isUploadFileJSON = true;
            }
            break;
          case "AmazonClaude_APIKey":
            element.value = mapForSave
              ? self.setup.amazonClaude_APIKey
              : element.value;
            self.setup.amazonClaude_APIKey = element.value;
            break;
          case "GPTMode":
            element.value = mapForSave
              ? self.setup.GPTMode
                ? "1"
                : "0"
              : element.value == "1";
            self.setup.GPTMode = element.value;
            break;
          case "GPTRepeatTime":
            element.value = mapForSave
              ? self.setup.GPTMode == "0"
                ? null
                : self.setup.GPTRepeatTime
              : self.setup.GPTMode == "0"
              ? null
              : element.value;
            self.setup.GPTRepeatTime = element.value;
            break;
          case "Model":
            element.value = mapForSave
              ? self.setup.GPTMode == "0"
                ? null
                : self.setup.Model
              : self.setup.GPTMode == "0"
              ? null
              : element.value;
            self.setup.Model = element.value;
            break;
          case "Questions":
            element.value = mapForSave
              ? self.setup.GPTMode == "0"
                ? null
                : self.setup.Questions
              : self.setup.GPTMode == "0"
              ? null
              : element.value;
            self.setup.Questions = element.value;
            break;
          case "SSO":
            element.value = mapForSave
              ? self.setup.SSO
                ? "1"
                : "0"
              : element.value == "1";
            self.setup.SSO = element.value;
            break;
          case "SSOChat":
            element.value = mapForSave
              ? self.setup.SSOChat
                ? "1"
                : "0"
              : element.value == "1";
            self.setup.SSOChat = element.value;
            break;
          case "Instance":
            element.value = mapForSave ? self.setup.instance : element.value;
            self.setup.instance = element.value;
            break;
          case "Domain":
            element.value = mapForSave ? self.setup.domain : element.value;
            self.setup.domain = element.value;
            break;
          case "TenantId":
            element.value = mapForSave ? self.setup.tenantId : element.value;
            self.setup.tenantId = element.value;
            break;
          case "ClientId":
            element.value = mapForSave ? self.setup.clientId : element.value;
            self.setup.clientId = element.value;
            break;
          case "CallbackPath":
            element.value = mapForSave
              ? self.setup.callbackPath
              : element.value;
            self.setup.callbackPath = element.value;
            break;
          case "ClientSecret":
            element.value = mapForSave
              ? self.setup.clientSecret
              : element.value;
            self.setup.clientSecret = element.value;
            break;
          case "APIScope":
            element.value = mapForSave ? self.setup.APIScope : element.value;
            self.setup.APIScope = element.value;
            break;
          case "URLConfig":
            element.value = mapForSave ? self.setup.URLConfig : element.value;
            self.setup.URLConfig = element.value;
            break;
          case "SecurityGroupTenantID":
            element.value = mapForSave
              ? self.setup.SecurityGroupTenantID
              : element.value;
            self.setup.SecurityGroupTenantID = element.value;
            self.oldsetup.SecurityGroupTenantID = self.setup.SecurityGroupTenantID;
            break;
          case "SecurityGroupClientID":
            element.value = mapForSave
              ? self.setup.SecurityGroupClientID
              : element.value;
            self.setup.SecurityGroupClientID = element.value;
            self.oldsetup.SecurityGroupClientID = self.setup.SecurityGroupClientID;
            break;
          case "SecurityGroupClientSecrete":
            element.value = mapForSave
              ? self.setup.SecurityGroupClientSecrete
              : element.value;
            self.setup.SecurityGroupClientSecrete = element.value;
            self.oldsetup.SecurityGroupClientSecrete = self.setup.SecurityGroupClientSecrete;
            break;
          case "SSOGroups":
            if (mapForSave) {
              element.value = self.syncSSO ? "1" : "0";
            } else {
              self.syncSSO = element.value == "1";
            }
            break;
          case "EmbeddingLoadBalanceEnable":
            element.value = mapForSave
              ? self.setup.EmbLoadBalanceMode
                ? "1"
                : "0"
              : element.value == "1";
            self.setup.EmbLoadBalanceMode = element.value;
            break;
          default:
            break;
        }
      });
    },
    EditUser(temp) {
      let self = this;
      self.edit.id = temp.id;
      self.edit.key = temp.key;
      self.edit.value = temp.value;

      self.Editdialog = true;
    },
    ValidatesetupListAzureOpenAIEndpoint() {
      let self = this;
      if (self.setupListAzureOpenAIEndpoint.length == 0) {
        return false;
      }
      for (let i = 0; i < self.setupListAzureOpenAIEndpoint.length; i++) {
        let item = self.setupListAzureOpenAIEndpoint[i];
        if (
          item.priorityDisplay == 0 ||
          item.priorityDisplay == "" ||
          item.priorityDisplay == null ||
          item.azureOpenAIUrl == "" ||
          item.azureOpenAIUrl == null ||
          item.azureOpenAIAPIKey == "" ||
          item.azureOpenAIAPIKey == null
        ) {
          return false;
        }
      }
      return true;
    },
    ValidateFastMode() {
      let self = this;
      if (self.setup.GPTMode != "1") {
        return true;
      }

      if (
        self.setup.GPTRepeatTime == "0" ||
        self.setup.GPTRepeatTime == 0 ||
        self.setup.GPTRepeatTime == null ||
        self.setup.GPTRepeatTime == undefined
      ) {
        return false;
      } else if (
        self.setup.Model == "" ||
        self.setup.Model == null ||
        self.setup.Model == undefined
      ) {
        return false;
      } else if (
        self.setup.Questions == "" ||
        self.setup.Questions == null ||
        self.setup.Questions == undefined
      ) {
        return false;
      }
      return true;
    },
    Update() {
      try {
        let self = this;
        if (
          !self.ValidatesetupListAzureOpenAIEndpoint() ||
          !self.ValidateFastMode()
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        self.dialog = true;
        self.MapSetupList(self.setupList, true);
        let req = {
          listDbsettings: self.setupList,
          listAzureOpenAIEndpoint: self.setupListAzureOpenAIEndpoint,
          listOpenIDConnect: self.setupOpenIDConnectList,
        };
        self.$call.GetSetupUpdateGeneral(
          req,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.Get();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    copyClipboard() {
      this.$refs.clone.focus();
      document.execCommand("copy");
    },
    copyClipboardFullSteam() {
      this.$refs.cloneFullSteam.focus();
      document.execCommand("copy");
    },
    uploadFile(e) {
      let self = this;
      if (e.length > 0) {
        switch (e[0].type) {
          case "application/json":
            self.tempFileJSON = e[0];
            console.log("fileJSON", self.tempFileJSON);
            self.readFile(self.tempFileJSON);
            break;
          default:
          // code block
        }
      }
    },
    readFile(file) {
      let self = this;
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function () {
        self.setup.fileJSON = reader.result;
        self.isUploadFileJSON = false;
        console.log("self.setup.fileJSON", self.setup.fileJSON);
      };
      reader.onerror = function () {
        alert("Failed to read file!");
      };
    },
    Delete(index) {
      let self = this;
      self.$swal
        .fire({
          title: this.$t("confirmDeletion"),
          text: this.$t("confirmDeletionAzureOpenAI"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.setupListAzureOpenAIEndpoint.splice(index, 1);
          }
        });
    },
    Add() {
      let self = this;
      let temp = {
        id: 0,
        azureOpenAIUrl: null,
        azureOpenAIAPIKey: null,
        priorityDisplay: null,
        showValue: false,
      };
      self.setupListAzureOpenAIEndpoint.push(temp);
    },
    AddOpenIDConnect(Provider) {
      let self = this;
      let instance = null;
      if (Provider == "Microsoft") {
        instance = "https://login.microsoftonline.com/";
      }
      let temp = {
        id: 0,
        provider: Provider,
        sso: false,
        ssoChat: false,
        instance: instance,
        domain: null,
        tenantId: null,
        clientId: null,
        callbackPath: null,
        clientSecret: null,
        apiScope: null,
        urlConfig: null,
      };
      self.setupOpenIDConnectList.push(temp);
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async GetDDLModelDataAzureProvider() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLModelDataAzureProvider(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDModelShow = dataResponse.data;
          } else {
            self.DDModelShow = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
  },
};
</script>

<style scoped>
.setup-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

.header-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.header-content {
  color: white;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 300;
  margin: 0;
  margin-bottom: 8px;
}

.page-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 24px;
}

.date-display {
  color: white;
  font-size: 1.1rem;
  opacity: 0.9;
}

.save-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white !important;
}

.config-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.config-card {
  border-radius: 16px !important;
  border: none;
  background: white;
  transition: all 0.3s ease;
  width: 100%;
}

.config-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

.card-header {
  background: linear-gradient(135deg, #0e81df 30%, #e2e8f0 100%);
  border-radius: 16px 16px 0 0 !important;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
}

.card-header .v-card__title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #495057;
}

.card-content {
  padding: 24px;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-title::before {
  content: "";
  width: 4px;
  height: 20px;
  background: #667eea;
  margin-right: 12px;
  border-radius: 2px;
}

.section-subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #6c757d;
  margin-bottom: 16px;
}

.endpoint-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #e9ecef;
}

.priority-field {
  max-width: 120px;
}

.toggle-btn,
.delete-btn {
  background: rgba(108, 117, 125, 0.1) !important;
}

.add-endpoint-btn {
  color: #1867C0 !important;
  border: 2px dashed #1867C0 !important;
  background: transparent !important;
  border-radius: 12px;
  height: 56px;
  width: 100%;
  margin-top: 16px;
  transition: all 0.3s ease;
}

.add-endpoint-btn:hover {
  border-color: #667eea !important;
  background: rgba(102, 126, 234, 0.05) !important;
}

.storage-section {
  margin-bottom: 24px;
}

.service-tabs .v-tabs {
  border-radius: 12px;
  background: #f8f9fa;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.setting-item {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
}

.switch-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

.modern-switch .v-input__slot {
  background: transparent !important;
}

.loading-card {
  border-radius: 16px !important;
  text-align: center;
}

.loading-text {
  font-size: 1.1rem;
  color: #495057;
  font-weight: 500;
}

/* Form field styling */
.v-text-field--outlined {
  border-radius: 12px;
}

.v-text-field--outlined .v-input__control .v-input__slot {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.v-text-field--outlined.v-input--is-focused .v-input__control .v-input__slot {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .header-section {
    flex-direction: column;
    text-align: center;
    gap: 24px;
  }

  .header-actions {
    flex-direction: column;
    gap: 16px;
  }

  .page-title {
    font-size: 2rem;
  }
}

@media (max-width: 600px) {
  .setup-container .v-container {
    padding: 16px;
  }

  .header-section {
    padding: 24px;
  }

  .config-card {
    margin-bottom: 16px;
  }

  .card-content {
    padding: 16px;
  }
}
.save-action-card {
  /* background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%) !important; */
  border: 1px solid rgba(24, 103, 192, 0.12);
  border-radius: 16px !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 0 0 rgba(24, 103, 192, 0.15) !important;
}

.save-action-content {
  padding: 20px 24px !important;
}

.save-action-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.save-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.save-text {
  display: flex;
  flex-direction: column;
}

.save-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1867c0;
  margin: 0;
  line-height: 1.2;
}

.save-subtitle {
  font-size: 0.875rem;
  color: #6c757d;
  margin: 2px 0 0 0;
  line-height: 1.3;
}

.save-action-button {
  min-width: 200px !important;
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.save-action-button:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(24, 192, 60, 0.35) !important;
}

.save-action-button:active {
  transform: translateY(0) !important;
}

.save-action-button .v-btn__prepend {
  margin-right: 8px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .save-action-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
  
  .save-info {
    justify-content: center;
    text-align: center;
  }
  
  .save-action-button {
    width: 100%;
    min-width: unset !important;
  }
}

@media (max-width: 600px) {
  .save-action-content {
    padding: 16px 20px !important;
  }
  
  .save-title {
    font-size: 1rem;
  }
  
  .save-subtitle {
    font-size: 0.8rem;
  }
  
  .save-action-button {
    height: 44px !important;
    font-size: 0.9rem !important;
  }
  
  .save-info .v-icon {
    display: none;
  }
}

/* Animation for better UX */
.save-action-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Loading state for save button */
.save-action-button.v-btn--loading {
  background: linear-gradient(135deg, #64b5f6 0%, #42a5f5 100%) !important;
}


.sticky-save-btn {
  position: fixed;
  top: 130px;
  right: 30px;
  z-index: 1000;
  max-width: 800px;
  box-shadow: 0px 6px 12px rgba(14, 87, 8, 0.4) !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

/* Animation เมื่อ sticky button ปรากฏ */
.sticky-save-btn {
  animation: slideInFromRight 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
}

/* Enhanced hover effect สำหรับ sticky button */
.sticky-save-btn:hover {
  transform: translateX(-5px) scale(1.02);
  box-shadow: 0px 12px 20px rgba(14, 69, 133, 0.5) !important;
}

/* Responsive สำหรับ sticky button */
@media (max-width: 960px) {
  .sticky-save-btn {
    width: 200px;
    right: 20px;
    top: 120px;
  }
}

@media (max-width: 600px) {
  .sticky-save-btn {
    width: 180px;
    right: 15px;
    top: 100px;
    font-size: 0.9rem !important;
  }
}

/* ซ่อน sticky button เมื่อ dialog เปิด */
.v-overlay--active ~ .setup-container .sticky-save-btn {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

</style>
